import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthGaurd } from "@guards/auth.gaurd";
import { LoginComponent } from "@pages/auth/login/login.component";
import { DashboardComponent } from "@pages/dashboard/dashboard.component";
import { DeliveryInfoComponent } from "@pages/delivery-info/delivery-info.component";
import { MessagesComponent } from "@pages/messages/messages.component";
import { OrderDetailsComponent } from "@pages/orders/order-details/order-details.component";
import { OrderListComponent } from "@pages/orders/order-list/order-list.component";
import { ProductInputPageComponent } from "@pages/product/product-input/product-input-page.component";
import { ProductListPageComponent } from "@pages/product/product-list/product-list.component";
import { ProfileComponent } from "@pages/profile/profile.component";
import { ShopGuidelineComponent } from "@pages/shop-guideline/shop-guideline.component";
import { UserGuideComponent } from "@pages/user-guide/user-guide.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },

  // static routes
  {
    path: "dashboard",
    canActivate: [AuthGaurd],
    component: DashboardComponent,
  },

  {
    path: "products",
    canActivate: [AuthGaurd],
    component: ProductListPageComponent,
  },

  {
    path: "product_input/:id",
    canActivate: [AuthGaurd],
    component: ProductInputPageComponent,
  },

  { path: "orders", canActivate: [AuthGaurd], component: OrderListComponent },

  // Messages with shoppers; ?c=<conversation id> opens one (email digest links).
  { path: "messages", canActivate: [AuthGaurd], component: MessagesComponent },

  {
    path: "delivery_information",
    canActivate: [AuthGaurd],
    component: DeliveryInfoComponent,
  },

  {
    path: "shop_guideline",
    canActivate: [AuthGaurd],
    component: ShopGuidelineComponent,
  },

  {
    path: "profile",
    canActivate: [AuthGaurd],
    component: ProfileComponent,
  },

  {
    path: "user_guide",
    canActivate: [AuthGaurd],
    component: UserGuideComponent,
  },

  {
    path: "order_details/:id",
    canActivate: [AuthGaurd],
    component: OrderDetailsComponent,
  },

  {
    path: "login",
    component: LoginComponent,
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
